import type { ChatMessage } from "./types";

/** Checks if a message is an unread customer message. Shared for consistency across providers. */
export function isUnreadCustomerMessage(message: ChatMessage): boolean {
    return message.senderType === "customer" && message.receiptStatus !== "read";
}
